import { useRef } from 'react';
import { Container, Divider, Stack, Typography } from '@mui/material';

import Button from 'components/Common/CustomButton';
import { getBlobUrl } from 'utils/helpers';

function ImageUploadContainer({ imgValue, setImgValue }: { imgValue: any; setImgValue: any }) {
    const ref: any = useRef(null);

    const handleClick = () => {
        ref.current && ref.current.click();
    };
    const handleImageChange = (event: any) => {
        setImgValue(event.target.files[0]);
    };

    return (
        <>
            <Stack p={10}>
                <Typography>Update Profile Photo</Typography>
                <Divider />
                <Typography>
                    You may drag and drop or select the photo you wish to use. Please refer to our Terms & Services guidelines for profile
                    photos.
                </Typography>
            </Stack>
            <Container
                sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    borderStyle: 'dotted',
                    my: 6,
                    borderColor: '#D1D5DB',
                }}
            >
                <Typography sx={{ fontSize: 18, fontWeight: 400 }}>Drag and drop file here to upload</Typography>
                or
                <Button
                    variant="outlined"
                    onClick={handleClick}
                    backgroundColor="white"
                    fontSize={14}
                    title="Select File"
                    sx={{ width: '20%' }}
                />
                <input ref={ref} type={'file'} onChange={handleImageChange} style={{ visibility: 'hidden' }} />
                {/* <Typography sx={{ fontSize: 12 }}>
                Maximum upload file size is 20 MB.
            </Typography> */}
                {imgValue && (
                    <Stack direction="row" justifyContent="center" alignItems="center" sx={{ maxWidth: '200px', maxHeight: '200px' }}>
                        <img
                            src={getBlobUrl(imgValue)}
                            alt="profile pic"
                            style={{ width: '200px', height: '200px', objectFit: 'contain' }}
                        />
                    </Stack>
                )}
            </Container>
        </>
    );
}

export default ImageUploadContainer;
